import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { isRouteLocked } from '../TransferTo/utils';
import { getWaveChoiceRouteId } from '../../../store/reducers/route';
import {
  CHOICE_ROUTE_CONTINUE_MESSAGE_$,
  CHOICE_ROUTE_WARNING,
  DISMISS,
  UNABLE_TRANSFER_TO_LOCKED_ROUTE,
} from '../../../constants/strings';
import { formatMessage } from '../../../utils/string';
import { showNotification } from '../../../store/actions/notifications';
import { NotificationType } from '../../../features/Notifier';

const useSelectRouteHandler = (defaultState = null, defaultRouts = []) => {
  const dispatch = useDispatch();
  const [selectedRoute, setSelectedRoute] = useState(defaultState);
  const [availableRoutes, setAvailableRoutes] = useState(defaultRouts);

  const onSelectRoute = useCallback(
    async (value) => {
      if (value) {
        const isLocked = isRouteLocked(availableRoutes, value);
        if (!isLocked) {
          const choiceRouteId = await dispatch(getWaveChoiceRouteId(value));
          if (choiceRouteId) {
            const message = `${CHOICE_ROUTE_WARNING} ${formatMessage(
              CHOICE_ROUTE_CONTINUE_MESSAGE_$,
              choiceRouteId
            )}`;
            dispatch(
              showNotification({
                key: 'transfer-choice-route-error',
                type: NotificationType.ACTION,
                message,
                buttonText: DISMISS,
              })
            );
            setSelectedRoute(null);
            return;
          }
        } else {
          isLocked &&
            dispatch(
              showNotification({
                key: 'transfer-locked-route-error',
                type: NotificationType.ACTION,
                message: UNABLE_TRANSFER_TO_LOCKED_ROUTE,
                buttonText: DISMISS,
              })
            );
        }
      }
      setSelectedRoute(value);
    },
    [availableRoutes, dispatch]
  );

  return [selectedRoute, onSelectRoute, setAvailableRoutes, setSelectedRoute];
};

export default useSelectRouteHandler;
